module.exports = __webpack_public_path__ + "static/img/SmileAnimation_grapefruit.332c4d1.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/smiles/SmileAnimation_grapefruit.gif
// module id = 60sp
// module chunks = 0